/* =========================================================
   VORVYPRINT — MAIN JAVASCRIPT
   ========================================================= */

(function () {
  'use strict';

  /* ---------------------------------------------------------
     MOBILE NAVIGATION
     --------------------------------------------------------- */

  function initMobileMenu() {
    const menuButton = document.querySelector('[data-vp-menu]');
    const navigation = document.querySelector('[data-vp-nav]');

    if (!menuButton || !navigation) {
      return;
    }

    menuButton.addEventListener('click', function () {
      const isOpen = navigation.classList.toggle('is-open');

      menuButton.setAttribute(
        'aria-expanded',
        isOpen ? 'true' : 'false'
      );
    });

    /* Close menu when a navigation link is clicked */
    const navLinks = navigation.querySelectorAll('a');

    navLinks.forEach(function (link) {
      link.addEventListener('click', function () {
        navigation.classList.remove('is-open');
        menuButton.setAttribute('aria-expanded', 'false');
      });
    });

    /* Close menu when clicking outside */
    document.addEventListener('click', function (event) {
      if (
        !navigation.contains(event.target) &&
        !menuButton.contains(event.target)
      ) {
        navigation.classList.remove('is-open');
        menuButton.setAttribute('aria-expanded', 'false');
      }
    });

    /* Close menu with Escape */
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        navigation.classList.remove('is-open');
        menuButton.setAttribute('aria-expanded', 'false');
      }
    });
  }


  /* ---------------------------------------------------------
     INITIALIZE
     --------------------------------------------------------- */

  function initVorvyprint() {
    initMobileMenu();
  }


  /* ---------------------------------------------------------
     SHOPIFY DOM READY
     --------------------------------------------------------- */

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initVorvyprint
    );
  } else {
    initVorvyprint();
  }


  /* ---------------------------------------------------------
     SHOPIFY THEME EDITOR SUPPORT
     --------------------------------------------------------- */

  document.addEventListener(
    'shopify:section:load',
    function () {
      initVorvyprint();
    }
  );

})();